import {
  ADD_PRODUCT_TO_CART, REMOVE_ACTIVE_PRODUCTS, CLEAR_CART,
  INCREMENT_PRODUCT, DECREMENT_PRODUCT, SET_ACTIVE_PRODUCT, RESET_ACTIVE_PRODUCT,
  SET_ALL_ACTIVE, RESET_ALL_ACTIVE, SYNC_CART_WITH_SERVER, UPDATE_CART_ON_SERVER,
  REMOVE_PRODUCT_FROM_CART
} from "../actions/cart_actions";

const initialState = {
  productsInCart: [],
  productsCount: 0,
  allActive: false,
  allNoActive: true,
  requestProgress: false,
  requestFailed: false,
};

const checkAllActive = (list, obj, newActiveStatus) => {
  if (!Array.isArray(list) || list.length === 0 || !newActiveStatus) return false;
  return list.every(item => {
    if (item.product.id === obj.product.id) {
      return newActiveStatus;
    } else {
      return item.active;
    }
  });
}

const checkAllNoActive = (list, obj, newActiveStatus) => {
  if (!Array.isArray(list) || list.length === 0) return true;
  let allNoActive = true;
  list.forEach(item => {
    if (item.product.id === obj.product.id) {
      allNoActive *= !newActiveStatus;
    } else {
      allNoActive *= !item.active;
    };
  });
  return !!allNoActive;
}

export const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_PRODUCT_TO_CART: {

      return {
        ...state,
        productsInCart: [...state.productsInCart, action.payload],
        productsCount: state.productsCount + 1,
        allActive: checkAllActive(state.productsInCart, action.payload, true),
        allNoActive: false,
        requestProgress: false,
        requestFailed: false,
      }
    }
    case REMOVE_PRODUCT_FROM_CART: {
      return {
        ...state,
        productsInCart: [...state.productsInCart.filter(productInCart => productInCart.product.id !== action.payload.product.id)],
        productsCount: state.productsCount - 1,
        allActive: checkAllActive(state.productsInCart, action.payload, false),
        allNoActive: checkAllNoActive(state.productsInCart, action.payload, false),
        requestProgress: false,
        requestFailed: false,
      }
    }
    case SET_ALL_ACTIVE: {
      return {
        ...state,
        productsInCart: [
          ...state.productsInCart.map(productInCart => {
            return { ...productInCart, active: true };
          })
        ],
        allActive: true,
        allNoActive: false,
        requestProgress: false,
        requestFailed: false,
      }
    }
    case RESET_ALL_ACTIVE: {
      return {
        ...state,
        productsInCart: [
          ...state.productsInCart.map(productInCart => {
            return { ...productInCart, active: false };
          })
        ],
        allActive: false,
        allNoActive: true,
        requestProgress: false,
        requestFailed: false,
      }
    }

    case SET_ACTIVE_PRODUCT: {
      return {
        ...state,
        productsInCart: [
          ...state.productsInCart.map(productInCart => {
            if (productInCart.product.id === action.payload.product.id) {
              return { ...productInCart, active: true };
            }
            return productInCart;
          })
        ],
        allActive: checkAllActive(state.productsInCart, action.payload, true),
        allNoActive: false,
        requestProgress: false,
        requestFailed: false,
      }
    }
    case RESET_ACTIVE_PRODUCT: {
      return {
        ...state,
        productsInCart: [
          ...state.productsInCart.map(productInCart => {
            if (productInCart.product.id === action.payload.product.id) {
              return { ...productInCart, active: false };
            }
            return productInCart;
          })
        ],
        allActive: false,
        allNoActive: checkAllNoActive(state.productsInCart, action.payload, false),
        requestProgress: false,
        requestFailed: false,
      }
    }
    case INCREMENT_PRODUCT: {
      return {
        ...state,
        productsInCart: [
          ...state.productsInCart.map(productInCart => {
            if (productInCart.product.id === action.payload) {
              return {
                ...productInCart,
                count: productInCart.count + productInCart.product.multiple_count
              };
            }
            return productInCart;
          })
        ],
        requestProgress: false,
        requestFailed: false,
      }
    }
    case DECREMENT_PRODUCT: {
      return {
        ...state,
        productsInCart: [
          ...state.productsInCart.map(productInCart => {
            if (productInCart.product.id === action.payload) {
              return {
                ...productInCart,
                count: productInCart.count - productInCart.product.multiple_count
              };
            }
            return productInCart;
          })
        ],
        requestProgress: false,
        requestFailed: false,
      }
    }
    case REMOVE_ACTIVE_PRODUCTS: {
      if (state.allActive) {
        return {
          ...state,
          productsInCart: [],
          productsCount: 0,
          allActive: false,
          allNoActive: true,
          requestProgress: false,
          requestFailed: false
        }
      }
      return {
        ...state,
        productsCount: state.productsInCart.reduce((acc, productInCart) => {
          return acc + (productInCart.active ? 0 : 1);
        }, 0),
        productsInCart: [...state.productsInCart.filter(productInCart => !productInCart.active)],
        allActive: false,
        allNoActive: true,
      }
    }
    case SYNC_CART_WITH_SERVER: {
      return {
        ...state,
        productsInCart: [...action.payload],
        productsCount: action.payload.length,
        allActive: action.payload.every(productInCart => productInCart.active),
        allNoActive: action.payload.every(productInCart => !productInCart.active),
        requestProgress: false,
        requestFailed: false,
      }
    }
    case CLEAR_CART: {
      return {
        ...state,
        productsInCart: [],
        productsCount: 0,
        allActive: false,
        allNoActive: true,
        requestProgress: false,
        requestFailed: false,
      }
    }
    default: return state;
  }
}
